import { render } from "./create.vue?vue&type=template&id=3aa51731&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=3aa51731&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa51731"]])

export default __exports__